import { Base64 } from "js-base64";
export function codeError(error, code) {
    return Object.assign(error, { code });
}
export const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export function encodeToBase64(str) {
    return Base64.encode(str);
}
export function decodeFromBase64(str) {
    return Base64.decode(str);
}
